import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './api/client';

const NO_RETRY = new Set([400, 401, 403, 404, 409, 422]);

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, error) => !(isApiError(error) && NO_RETRY.has(error.status)) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}
